import { IconShieldCheckmarkFilledShape } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { configGetFeature } from 'common/helper/config/get-feature';
import { i18nTranslate } from 'common/helper/i18n/translate';

import { PropertyCardTagTemplatePropsInterface } from './tag-template-props.interface';

export const PropertyCardTagTemplate: FunctionalComponent<PropertyCardTagTemplatePropsInterface> = (props) => {
  const { classNamePrefix = 'card__tag' } = props;

  if (props.exclusive) {
    return (
      <p
        className={`text text--uppercase
      tag tag--style3 ${props.class}`}
      >
        {i18nTranslate('Exclusive')}
      </p>
    );
  } else if (props.verified) {
    return (
      <p
        className={`text text--uppercase
      tag tag--style2 ${props.class}`}
      >
        {configGetFeature('verified_first').enabled ? (
          <IconShieldCheckmarkFilledShape className='tag__icon-verified' />
        ) : null}
        {i18nTranslate('Verified')}
      </p>
    );
  } else if (props.listingLevel === 'direct_from_developer_premium') {
    return (
      <p className={`${classNamePrefix} ${classNamePrefix}--property-premium ${props.class}`}>
        {i18nTranslate('Developer listing')}
      </p>
    );
  } else if (props.listingLevel === 'direct_from_developer_featured') {
    return (
      <p className={`${classNamePrefix} ${classNamePrefix}--property-featured ${props.class}`}>
        {i18nTranslate('Developer listing')}
      </p>
    );
  } else if (props.premium) {
    return (
      <p className={`${classNamePrefix} ${classNamePrefix}--property-premium ${props.class}`}>
        {i18nTranslate('Premium')}
      </p>
    );
  } else if (props.featured) {
    return (
      <p className={`${classNamePrefix} ${classNamePrefix}--property-featured ${props.class}`}>
        {i18nTranslate('Featured')}
      </p>
    );
  } else if (props.withAreaSpecialist) {
    return (
      <div className={`text text--uppercase tag tag--style4 ${props.class}`}>{i18nTranslate('Community Expert')}</div>
    );
  }
};
